module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/th_shikoku-bc46c67fe085838c3541df79ab60124b.jpg";